// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__mtX6z","legal":"footer_legal__VF2BW","social":"footer_social__6uBoK"};